module.exports = __webpack_public_path__ + "static/1-c5b0a19759f32b83734c38f1e646e9c4.png";